// extracted by mini-css-extract-plugin
module.exports = {"container":"BookingButton_container__17m9x","instant":"BookingButton_instant__1WliQ","lightningBoltIcon":"BookingButton_lightningBoltIcon__1koyC"};